<template>
  <div class="IntervalIOListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :item-class="row_classes"
      item-key="MessageId"
      hide-default-footer
      disable-pagination
    />
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },
  methods: {
    row_classes(item) {
      debugger
      if (item.DMP == 1) {
        return "bg-green"; //can also return multiple classes e.g ["orange","disabled"]
      }
      // else{
      //   return "bg-green"; //can also return multiple classes e.g ["orange","disabled"]
      // }
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("BeginDate"),
          value: "BeginDate",
        },
        {
          text: this.$t("DayName"),
          value: "EnterDayName",
        },
        {
          text: this.$t("BeginTime"),
          value: "BeginTime",
        },

        {
          text: this.$t("EndTime"),
          value: "EndTime",
        },
        {
          text: this.$t("EndDate"),
          value: "EndDate",
        },
        {
          text: this.$t("DurationTime"),
          value: "Duration",
        },
      ],
    };
  },
};
</script>

<style>
.bg-green {
  background-color: var(--background-green);
}
</style>